// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-modal{
    display: flex;
    align-items: inherit;
    width: 100%;
    max-height: calc(100% - 2rem);
    overflow: auto;
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%,-50%);
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.login-modal::-webkit-scrollbar {
    display: none;
}
.login-carousel{
    width: 60%;
    min-width: 25rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.login-grid{
    min-width: 20.625rem;
    max-width: 23.4375rem;
    width: 30%;
    min-height: 31.25rem;
    padding: 1.25rem 1.25rem 0 1.25rem;
    background-color: #f6f8fa;
    border-radius: 1.75rem;
    box-sizing: border-box;  
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.login-grid::-webkit-scrollbar {
    display: none;   /* Chrome、Safari 和 Opera */
}
.login-title{
    margin: 1rem 0px;
    font-weight: bold;
    text-align: center;
    font-size: 1.5rem;
    color: #212843; 
}
.login-version{
    margin: 1rem 0px;
    color: #212843;
}
.login-username{
    margin-bottom:  0.625rem;;
}
.login-paassword{
    margin-bottom: 0.625rem;
}
.login-or{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.css-13cymwt-control{
    border-radius: 0.5rem;
}
.swiper {
    min-width: 18.75rem;
}
.swiper-slide {
    text-align: center;
    font-size: 1.75rem;
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-swiper-slide{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.login-swiper-slide img {
    min-width: 18.75rem;
    min-height: 18.75rem;
    width: 400px;
}
.swiper {
    margin-left: auto;
    margin-right: auto;
}

`, "",{"version":3,"sources":["webpack://./Forms/Composite/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,+BAA+B;IAC/B,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;IACV,oBAAoB;IACpB,kCAAkC;IAClC,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa,IAAI,0BAA0B;AAC/C;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".login-modal{\n    display: flex;\n    align-items: inherit;\n    width: 100%;\n    max-height: calc(100% - 2rem);\n    overflow: auto;\n    position: absolute;\n    top: 50%;\n    left:50%;\n    transform: translate(-50%,-50%);\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n.login-modal::-webkit-scrollbar {\n    display: none;\n}\n.login-carousel{\n    width: 60%;\n    min-width: 25rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.login-grid{\n    min-width: 20.625rem;\n    max-width: 23.4375rem;\n    width: 30%;\n    min-height: 31.25rem;\n    padding: 1.25rem 1.25rem 0 1.25rem;\n    background-color: #f6f8fa;\n    border-radius: 1.75rem;\n    box-sizing: border-box;  \n    overflow-y: auto;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n.login-grid::-webkit-scrollbar {\n    display: none;   /* Chrome、Safari 和 Opera */\n}\n.login-title{\n    margin: 1rem 0px;\n    font-weight: bold;\n    text-align: center;\n    font-size: 1.5rem;\n    color: #212843; \n}\n.login-version{\n    margin: 1rem 0px;\n    color: #212843;\n}\n.login-username{\n    margin-bottom:  0.625rem;;\n}\n.login-paassword{\n    margin-bottom: 0.625rem;\n}\n.login-or{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.css-13cymwt-control{\n    border-radius: 0.5rem;\n}\n.swiper {\n    min-width: 18.75rem;\n}\n.swiper-slide {\n    text-align: center;\n    font-size: 1.75rem;\n    color: #fff;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.login-swiper-slide{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.login-swiper-slide img {\n    min-width: 18.75rem;\n    min-height: 18.75rem;\n    width: 400px;\n}\n.swiper {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
